import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { SubscriberGroupsItemWire, ExternalMemberWire } from '../types';
import { SubscriberGroupItem, ExternalMemberValue } from 'app/area/subscriber-groups/form/types-store';
import { parseAsDateUTC, toISODatewithoutTimezone } from 'app/infrastructure/data/date';

export const mapSubscriberGroupFromWire = (wire: Partial<SubscriberGroupsItemWire>): SubscriberGroupItem => ({
  id: wire?.code?.v,
  description: wire?.code?.d,
  selfService: wire?.selfService,
  disabled: wire?.disabled
    ? parseAsDateUTC(wire?.disabled)
    : undefined,
  language: (wire?.language?.map(codeItemToStoreValue) ?? [])
    .map(item => ({
      value: item.value,
      description: item.description
    })),
  longDescription: (wire?.language?.map(codeItemToStoreValue) ?? [])
    .map(item => ({
      value: item.value,
      description: item.longDescription
    })),
  externalMembers: externalMemberToStoreValue(wire?.externalMember)
});

export const mapSubscriberGroupToWire = (subscriberGroup: SubscriberGroupItem): SubscriberGroupsItemWire => ({
  code: { v: subscriberGroup?.id, d: subscriberGroup?.description },
  language: subscriberGroup?.language?.map(languageItem => {
    const longDescription = subscriberGroup?.longDescription?.find(longDescriptionItem =>
      longDescriptionItem.value === languageItem.value)?.description?.trim();

    return {
      v: languageItem.value,
      d: languageItem.description?.trim(),
      ...(!!longDescription && { ld: longDescription })
    };
  }) ?? [],
  externalMember: mapExternalMemberToWire(subscriberGroup?.externalMembers),
  selfService: subscriberGroup?.selfService,
  disabled: subscriberGroup?.disabled
    ? toISODatewithoutTimezone(subscriberGroup?.disabled)()
    : undefined
});

export const externalMemberToStoreValue = (externalMembers: ExternalMemberWire[]): ExternalMemberValue[] =>
  externalMembers ? externalMembers?.map((externalMember, index) => ({
    memberNo: index + 1,
    name: externalMember?.name,
    emailAddress: externalMember?.emailAddress
  })) : [];

export const mapExternalMemberToWire = (externalMembers: ExternalMemberValue[]): ExternalMemberWire[] =>
  externalMembers?.map(externalMember => ({
    name: externalMember.name,
    emailAddress: externalMember.emailAddress
  })) ?? [];
